import { createContext, useEffect, useState } from 'react';
import { Shipment, ID } from '../../Models';
import deliveriesSubscription from './subscriptions';

const defaultState = {
    shipments: {} as Record<ID, Shipment>,
};
export const ShipmentsContext = createContext(defaultState);
export const useDeliveries = () => {
    const [shipments, setShipments] = useState({} as Record<ID, Shipment>);

    useEffect(() => {
        deliveriesSubscription((ds) => {
            if (ds) {
                const deliveriesRecord = ds.reduce(
                    (acc, delivery) => ({
                        ...acc,
                        [delivery.id]: delivery,
                    }),
                    {} as Record<ID, Shipment>,
                );
                setShipments(deliveriesRecord);
            }
        });
    }, []);

    return { shipments };
};
